import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=b163b642&scoped=true&"
import script from "./devices.vue?vue&type=script&lang=js&"
export * from "./devices.vue?vue&type=script&lang=js&"
import style0 from "./devices.vue?vue&type=style&index=0&id=b163b642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163b642",
  null
  
)

export default component.exports